import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateCostCodeAdjustmentRequest } from 'src/api/FiretrolApiClient';
import { ctcAdjustmentApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateCtcAdjustment(ctcJobId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: CreateCostCodeAdjustmentRequest) =>
      ctcAdjustmentApiClient.createCostCodeAdjustment(ctcJobId, request),
    meta: { successMessage: 'Adjustments Saved!' },
    onSettled: () => invalidateFor('ctcAdjustment.create', qc, { ctcJobId }),
  });
}
